module.exports = __webpack_public_path__ + "static/img/wing_740.7fcb310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_740.jpg
// module id = G2gs
// module chunks = 0